/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisputeStatus } from './DisputeStatus';
import {
    DisputeStatusFromJSON,
    DisputeStatusFromJSONTyped,
    DisputeStatusToJSON,
    DisputeStatusToJSONTyped,
} from './DisputeStatus';

/**
 * 
 * @export
 * @interface MatchDisputeFiledResponse
 */
export interface MatchDisputeFiledResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeFiledResponse
     */
    disputeId: string;
    /**
     * 
     * @type {DisputeStatus}
     * @memberof MatchDisputeFiledResponse
     */
    status: DisputeStatus;
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeFiledResponse
     */
    chatChannelId?: string;
}



/**
 * Check if a given object implements the MatchDisputeFiledResponse interface.
 */
export function instanceOfMatchDisputeFiledResponse(value: object): value is MatchDisputeFiledResponse {
    if (!('disputeId' in value) || value['disputeId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MatchDisputeFiledResponseFromJSON(json: any): MatchDisputeFiledResponse {
    return MatchDisputeFiledResponseFromJSONTyped(json, false);
}

export function MatchDisputeFiledResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchDisputeFiledResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'disputeId': json['disputeId'],
        'status': DisputeStatusFromJSON(json['status']),
        'chatChannelId': json['chatChannelId'] == null ? undefined : json['chatChannelId'],
    };
}

export function MatchDisputeFiledResponseToJSON(json: any): MatchDisputeFiledResponse {
    return MatchDisputeFiledResponseToJSONTyped(json, false);
}

export function MatchDisputeFiledResponseToJSONTyped(value?: MatchDisputeFiledResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disputeId': value['disputeId'],
        'status': DisputeStatusToJSON(value['status']),
        'chatChannelId': value['chatChannelId'],
    };
}

